import { Component, OnInit, Inject } from '@angular/core';
import * as moment from 'moment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-event-repeat',
    templateUrl: './event-repeat.component.html',
    styleUrls: ['./event-repeat.component.scss'],
    standalone: false
})
export class EventRepeatComponent implements OnInit {

  number: number = 1;
  interval: string = "weekly";
  endDate: UntypedFormControl;

  numbers: Array<number> = [];
  
  minDate: Date = moment.utc().add(1, 'day').toDate();
  maxDate: Date = moment.utc().add(5, 'year').toDate();

  daysOfWeek: string[] = [];

  weekDays = [
    { value: 'sunday', label: 'Su' },
    { value: 'monday', label: 'M' },
    { value: 'tuesday', label: 'T' },
    { value: 'wednesday', label: 'W' },
    { value: 'thursday', label: 'Th' },
    { value: 'friday', label: 'F' },
    { value: 'saturday', label: 'Sa' },
  ];

  constructor(
    private dialogRef: MatDialogRef<EventRepeatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar
  ) {
    this.dialogRef.addPanelClass?.('event-repeat-redesign');
    if(data.repeatEvent){
      this.interval = data.interval;
      this.endDate = new UntypedFormControl(data.repeatEndDate);
      this.daysOfWeek = data.daysOfWeek;
    } else {
      this.daysOfWeek = [data.dayOfWeek]
      this.endDate = new UntypedFormControl(this.minDate);
    }
  }

  ngOnInit() {
    //this.fillNumbersArray(30);
    this.number = 1;
  }

  intervalChange(newVal: string){
    switch(newVal) { 
      case "daily": { 
        //this.fillNumbersArray(30);

        if(this.number > 30){
          this.number = 30;
        }

        break; 
      } 
      case "weekly": { 
        //this.fillNumbersArray(52);

        if(this.number > 52){
          this.number = 52;
        }

        break; 
      } 
      case "monthly": {
        //this.fillNumbersArray(12);

        if(this.number > 12){
          this.number = 12;
        }

        break;
      }
      default: { 
         //statements; 
         break; 
      } 
   } 
  }

  toggleDay(day: string) {
    if (this.daysOfWeek.includes(day)) {
      this.daysOfWeek = this.daysOfWeek.filter(d => d !== day);
    } else {
      this.daysOfWeek = [...this.daysOfWeek, day];
    }
  }

  submit() {

    let repeat = false;
    if(this.interval != null && this.endDate != null){
      repeat = true;

      if(!this.endDate.valid){
        this.snackBar.open('End Date not valid', null, {
          duration: 3000,
          verticalPosition: 'top'
        })
        return;
      }
    }

    let dialogResult: any = {
      submitted: true,
      repeat: repeat,
      number: this.number,
      interval: this.interval,
      endDate: this.endDate.value,
      daysOfWeek: this.daysOfWeek,
    }
    //alert(JSON.stringify(dialogResult));
    this.dialogRef.close(dialogResult)
  }

  // fillNumbersArray(number: number) {
  //   this.numbers = [];
  //   for (let i = 1; i <= number; i++) {
  //     this.numbers.push(i);
  //   }
  // }

}
